/*
 * @Author: LZH
 * @Date: 2023-04-03 10:43:52
 * @LastEditors: Do not edit
 * @LastEditTime: 2026-07-28 18:20:05
 * @Description:
 */
let baseconfig = {};
// if (process.env.NODE_ENV === 'test' || process.env.NODE_ENV === 'development') {  //测试环境和开发环境 npm run build:test
// baseconfig = {   //测试环境
//   baseUrlapi: 'https://apidev.xin-ptt.com:9001/xinpoc',
//   apiAudioUrl: 'https://apidev.xin-ptt.com/pocAudio',//测试录音文件平台
//   gpsUrlapi: 'https://apidev.xin-ptt.com/pocgps',//测试定位地址
//   sosUrlapi: "https://apidev.xin-ptt.com:9001/sos-ptt03", //sos
//   enclosureUrlapi: "https://apidev.xin-ptt.com:9001/enclosure-ptt03", //电子围栏
//   ak: 'gTV5Y1Vvppy3nUFTHQlIBvo5tVx4bqf8',//测试定位地址
//   tokenSl: { "Content-Type": "application/x-www-form-urlencoded" },
//   cardUrlApi: 'https://iotapitest.broadptt.com:8000',
//   extendtestUrl: 'http://extendtest.xin-ptt.com',
//   appId: '186d258e67554af58d1336534ba7a5a4',
//   appSecret: 'w3th4lb72wn8c4wl',
//   xinPatrolApi: 'https://apidev.xin-ptt.com:9001/xinpocPatrol'//巡更地址
// }

// baseconfig = {       //传奇数码-test
//   baseUrlapi: 'https://test.poc-global.com/api', //海外正式环境
//   apiAudioUrl: 'https://test.poc-global.com/audio',//录音文件平台
//   gpsUrlapi: 'https://test.poc-global.com/gps',//定位地址
//   sosUrlapi: "https://test.poc-global.com/sos-api", //sos
//   enclosureUrlapi: "https://test.poc-global.com/enclosure-api", //电子围栏
//   ak: 'gTV5Y1Vvppy3nUFTHQlIBvo5tVx4bqf8',//定位地址
//   tokenSl: { "Content-Type": "application/x-www-form-urlencoded" },
//   appId: 'c43dac490b6b4a3592fbb6921489204b',
//   appSecret: '46417p22z7d721d7'
// }

// } else if (process.env.NODE_ENV === 'productionagent') {
//   baseconfig = {       //芯平台代理
//     baseUrlapi: 'https://abroadproxy.xin-ptt.com/api', //海外正式环境
//     apiAudioUrl: 'https://abroadproxy.xin-ptt.com/audio',//录音文件平台
//     gpsUrlapi: 'https://abroadproxy.xin-ptt.com/gps',//定位地址
//     sosUrlapi: "https://abroadproxy.xin-ptt.com/sos", //sos
//     enclosureUrlapi: "https://apidev.xin-ptt.com:9001/enclosure-ptt03", //电子围栏
//     ak: 'gTV5Y1Vvppy3nUFTHQlIBvo5tVx4bqf8',//定位地址
//     tokenSl: { "Content-Type": "application/x-www-form-urlencoded" },
//     appId: 'c43dac490b6b4a3592fbb6921489204b',
//     appSecret: '46417p22z7d721d7'
//   }
// } else {
// baseconfig = {  //正式环境
//   baseUrlapi: 'https://proxy.xinpoc.com/api', //海外正式环境
//   apiAudioUrl: 'https://proxy.xinpoc.com/audio',//录音文件平台
//   gpsUrlapi: 'https://proxy.xinpoc.com/gps',//定位地址
//   sosUrlapi: "http://8.219.73.246:18088/sos-api", //sos
//   enclosureUrlapi: "https://proxy.xinpoc.com/enclosure-api",
//   xinPatrolApi: 'https://proxy.xinpoc.com/patrol',//巡更地址
//   ak: 'gTV5Y1Vvppy3nUFTHQlIBvo5tVx4bqf8',//定位地址,
//   tokenSl: { "Content-Type": "application/x-www-form-urlencoded" },
//   appId: 'c43dac490b6b4a3592fbb6921489204b',
//   appSecret: '46417p22z7d721d7'
// }

baseconfig = {       //芯平台代理
  baseUrlapi: 'https://abroadproxy.xin-ptt.com/api', //海外正式环境
  apiAudioUrl: 'https://abroadproxy.xin-ptt.com/audio',//录音文件平台
  gpsUrlapi: 'https://abroadproxy.xin-ptt.com/gps',//定位地址
  sosUrlapi: "https://abroadproxy.xin-ptt.com/sos", //sos
  enclosureUrlapi: "https://abroadproxy.xin-ptt.com/enclosure",
  xinPatrolApi: 'https://abroadproxy.xin-ptt.com/patrol',//巡更地址
  ak: 'gTV5Y1Vvppy3nUFTHQlIBvo5tVx4bqf8',//定位地址
  tokenSl: { "Content-Type": "application/x-www-form-urlencoded" },
  appId: 'c43dac490b6b4a3592fbb6921489204b',
  appSecret: '46417p22z7d721d7'
}

// }
// console.log(process.env.NODE_ENV, process.env)

export default baseconfig;
